// import { usePredictionStore } from 'modules/InputViewer/context/PredictionStoreContext';
import React from 'react';
import { useMstPredictionStore } from './contexts/MstPredictionStoreCtx';

// /**
//  * Makes sure that component renders if and only if prediction store exists in parent context
//  */
// export const withGuaranteedPredStore: React.FC = ({ children }) => {
//   const store = usePredictionStore();
//   if (!store) return null;
//   return <>{children}</>;
// };

// eslint-disable-next-line @typescript-eslint/ban-types
export const withGuaranteedPredStore = <P extends object>(Component: React.ComponentType<P>): React.FC<P> => {
  const Enhanced: React.FC<P> = (props: P) => {
    const store = useMstPredictionStore();
    return store ? <Component {...props} /> : null;
  };
  return Enhanced;
};
